import {
    REPORT_BUGS_USER_LIST,
    REPORT_BUGS_USER_LIST_SUCCESS,
    REPORT_BUGS_USER_LIST_ERROR,
    REPORT_BUGS_MENU,
    REPORT_BUGS_MENU_SUCCESS,
    REPORT_BUGS_MENU_ERROR,
    REPORT_BUGS_RESOURCE,
    REPORT_BUGS_RESOURCE_SUCCESS,
    REPORT_BUGS_RESOURCE_ERROR,
    REPORT_BUGS_BY_USER,
    REPORT_BUGS_BY_USER_SUCCESS,
    REPORT_BUGS_BY_USER_ERROR,
    REPORT_BUGS_PAGE_SET,
    REPORT_BUGS_ADD_MODAL_SET,
    REPORT_BUGS_ADD_CHANGE_SET,
    REPORT_BUGS_ADD,
    REPORT_BUGS_ADD_SUCCESS,
    REPORT_BUGS_ADD_ERROR,
    REPORT_BUGS_CANCEL,
    REPORT_BUGS_CANCEL_SUCCESS,
    REPORT_BUGS_CANCEL_ERROR,
    REPORT_BUGS_APPROVED,
    REPORT_BUGS_APPROVED_SUCCESS,
    REPORT_BUGS_APPROVED_ERROR,
    REPORT_BUGS_LIST,
    REPORT_BUGS_LIST_SUCCESS,
    REPORT_BUGS_LIST_ERROR
} from "../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    listbugs: {
        page: {
            current: 1,
            rows: 10
        }
    },
    userlist: {
        loading: false,
        data: []
    },
    menu: {
        loading: false,
        data: []
    },
    resource: {
        loading: false,
        data: []
    },
     add: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    cancel: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    approved: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
           
        },
        value: {
            
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case REPORT_BUGS_USER_LIST:
            return {
                ...state,
                loading: true,
                userlist: {
                    ...state.userlist
                }
            }
        case REPORT_BUGS_USER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                userlist: {
                    ...state.userlist,
                    ...action.payload
                }
            }
        case REPORT_BUGS_USER_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case REPORT_BUGS_MENU:
            return {
                ...state,
                loading: true,
                menu: {
                    ...state.menu
                }
            }
        case REPORT_BUGS_MENU_SUCCESS:
            return {
                ...state,
                loading: false,
                menu: {
                    ...state.menu,
                    ...action.payload
                }
            }
        case REPORT_BUGS_MENU_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case REPORT_BUGS_RESOURCE:
            return {
                ...state,
                loading: true,
                resource: {
                    ...state.resource
                }
            }
        case REPORT_BUGS_RESOURCE_SUCCESS:
            return {
                ...state,
                loading: false,
                resource: {
                    ...state.resource,
                    ...action.payload
                }
            }
        case REPORT_BUGS_RESOURCE_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case REPORT_BUGS_BY_USER:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }
        case REPORT_BUGS_BY_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case REPORT_BUGS_BY_USER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case REPORT_BUGS_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                },
                log: []
            }
        case REPORT_BUGS_ADD_MODAL_SET:
            return {
                ...state,
                add: {
                    ...state.add,
                    modal: action.payload
                }
            }
        case REPORT_BUGS_ADD_CHANGE_SET:
            return {
                ...state,
                add: {
                    ...state.add,
                    data: {
                        ...state.add.data,
                        ...action.payload
                    }
                }
            }
        case REPORT_BUGS_ADD:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: true
                }
            }
        case REPORT_BUGS_ADD_SUCCESS:
            return {
                ...state,
                add: {
                    ...state.add,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case REPORT_BUGS_ADD_ERROR:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case REPORT_BUGS_CANCEL:
            return {
                ...state,
                cancel: {
                    ...state.cancel,
                    loading: true
                }
            }
        case REPORT_BUGS_CANCEL_SUCCESS:
            return {
                ...state,
                cancel: {
                    ...state.cancel,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case REPORT_BUGS_CANCEL_ERROR:
            return {
                ...state,
                cancel: {
                    ...state.cancel,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case REPORT_BUGS_APPROVED:
            return {
                ...state,
                approved: {
                    ...state.approved,
                    loading: true
                }
            }
        case REPORT_BUGS_APPROVED_SUCCESS:
            return {
                ...state,
                approved: {
                    ...state.approved,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case REPORT_BUGS_APPROVED_ERROR:
            return {
                ...state,
                approved: {
                    ...state.approved,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
         case REPORT_BUGS_LIST:
            return {
                ...state,
                loading: true,
                listbugs: {
                    ...state.listbugs
                }
            }
        case REPORT_BUGS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                listbugs: {
                    ...state.listbugs,
                    ...action.payload
                }
            }
        case REPORT_BUGS_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        default:
            return { ...state };
    }
};